import Resource from '../../../api/resources/Resource'
import { Base64 } from 'js-base64'

class ClinicalCasePrintService extends Resource {
    async getCaseAPReportPdfForPrinting(laboratoryId, casId, casesAssociated) {
        return this.axios.get(`/clinical/laboratories/${laboratoryId}/cases/${casId}/reports`,
            {
                params: {
                    casesAssociated: casesAssociated,
                    encoded: true
                }
            }).then(response => response.data)
    }

    async downloadCaseAPReportPdf(laboratoryId, casId, casesAssociated) {
        return this.axios.get(`/clinical/laboratories/${laboratoryId}/cases/${casId}/reports`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    casesAssociated: casesAssociated,
                    encoded: false
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async getCaseAPReports(casIds) {
        return this.axios.get(`/clinical/laboratories/cases/reports`, {
            headers: {
                type: 'application/pdf'
            },
            params: {
                listCasIds: casIds.join(',')
            },
            responseType: 'arraybuffer'
        }).then(response => response.data)
    }

    encode(filterModel) {
        return Base64.encode(JSON.stringify(filterModel))
    }
}

export default new ClinicalCasePrintService()
